export const shouldFetchOrderItemForEditProduct = ({
  open,
  controlledMode = false,
  isPromoStore = false,
  initialItem = null,
  orderItemId = null,
  source = "order-cart",
} = {}) => {
  if (!open || !orderItemId) return false;

  const normalizedSource = String(source || "order-cart").trim();

  // Order Cart is live OrderItem state.
  // Sales Order Cart and Invoicing Cart are snapshot/workspace state.
  // Do not use one cart's persistence semantics for another.
  if (isPromoStore) return false;
  if (normalizedSource === "sales-order-cart") return false;
  if (normalizedSource === "invoicing-cart") return false;
  if (controlledMode && normalizedSource !== "order-cart") return false;

  return normalizedSource === "order-cart";
};
